import { organizationSectionEntityName, } from '../../../../../../backend/config/classifiers/OrganizationSectionClassifier/shared';
import { ContactManagementConfigContext } from '../../../../../../ui/providers';
import { useAnonymousStorageList } from '@juvare/platform-sdk-react/ui/hooks';
import React from 'react';
export function useOrganizationsSectionsNew() {
    const { appName } = React.useContext(ContactManagementConfigContext);
    const response = useAnonymousStorageList(organizationSectionEntityName, {
        filter: [{ column: 'status', op: '=', value: 'active' }],
        orderBy: [{ column: 'displayOrder' }, { column: 'name' }],
    }, appName);
    return Object.assign(Object.assign({}, response), { data: response.data
            ? {
                rows: response.data.rows,
                filteredRowCount: response.data.total,
            }
            : undefined, reload: response.mutate });
}
